var bookshelf = require("../index-extended");
require("./MeetingResolution");

module.exports = bookshelf.model("ResolutionVote", {
  entityName: "ResolutionVote",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "resolution_vote",
  meeting_resolution() {
    return this.belongsTo("MeetingResolution");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["mandate"];
    delete attrs["meeting_has_resolution"];
    delete attrs["meeting_resolution"];

    return attrs;
  },
});
